import type { SlotProps } from "input-otp"

import * as React from "react"

import { cx } from "@iyk/ui"
import { OTPInput } from "input-otp"

const InputOTP = React.forwardRef<
  React.ElementRef<typeof OTPInput>,
  React.ComponentPropsWithoutRef<typeof OTPInput> & { className?: string }
>(({ className, ...props }, ref) => (
  <OTPInput ref={ref} containerClassName={cx("flex items-center gap-2", className)} {...props} />
))
InputOTP.displayName = "InputOTP"

const InputOTPGroup = React.forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div"> & { className?: string }
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx("flex items-center w-full", className)} {...props} />
))
InputOTPGroup.displayName = "InputOTPGroup"

const InputOTPSlot = React.forwardRef<
  React.ElementRef<"div">,
  SlotProps & React.ComponentPropsWithoutRef<"div">
>(({ char, hasFakeCaret, isActive, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cx(
        "relative flex size-9",
        "grow items-center justify-center",
        "border-y border-r border-gray-4 text-sm transition-all first:rounded-l-sm first:border-l last:rounded-r-sm",
        isActive && "z-10 ring-2 ring-offset-white ring-gray-3",
        className,
      )}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="animate-caret-blink h-4 w-px bg-gray-12 duration-1000" />
        </div>
      )}
    </div>
  )
})
InputOTPSlot.displayName = "InputOTPSlot"

const InputOTPSeparator = React.forwardRef<
  React.ElementRef<"div">,
  React.ComponentPropsWithoutRef<"div">
>(({ ...props }, ref) => (
  <div ref={ref} role="separator" {...props}>
    -
  </div>
))
InputOTPSeparator.displayName = "InputOTPSeparator"

export { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot }
